import { BuyboxRegularOffer } from '@/components/buybox-new/types';

const providersFR = [
	119, 350, 381, 2, 337, 283, 1853, 2330, 677, 1875, 444, 239, 1796, 8, 201, 262, 296, 582, 588, 685, 688, 1732, 2472,
	1733, 1734, 1735, 1736, 1737, 1738, 1887, 1888, 1889, 1968, 2173, 2358, 2428, 10, 554, 2478, 2077, 415, 234, 59, 58,
	345, 2144, 324, 2140, 692, 190, 569, 475, 701, 542, 138, 559, 236, 3, 223, 315, 2285, 464, 310, 2145, 147, 551,
	1899, 68, 2139, 1967, 11, 61, 531, 2303, 538, 1945, 300, 2307, 35, 193, 513, 1715, 309, 1771, 550, 1754, 567, 2210,
	1860, 2286, 546, 192, 188,
];

const providersIT = [
	119, 350, 2, 1853, 337, 29, 39, 283, 696, 677, 444, 201, 262, 296, 582, 584, 607, 688, 689, 708, 1710, 1726, 1727,
	1728, 1729, 1730, 1894, 1895, 1896, 1897, 1968, 2108, 2141, 2243, 2275, 2358, 2388, 2389, 1796, 8, 2330, 10, 234,
	554, 2149, 2110, 692, 190, 524, 569, 475, 701, 559, 2478, 3, 100, 223, 315, 110, 2285, 464, 551, 359, 68, 11, 641,
	2111, 531, 538, 300, 222, 35, 1715, 2112, 309, 1771, 2109, 109, 567, 2113, 546, 188,
];

const providersES = [
	119, 350, 2, 283, 337, 2472, 1717, 1773, 2241, 149, 63, 64, 1854, 196, 201, 262, 296, 528, 607, 608, 684, 689, 1739,
	1740, 1741, 1742, 1743, 1890, 1968, 2141, 2243, 2275, 2358, 2393, 10, 393, 2474, 444, 257, 1970, 1796, 8, 2330, 677,
	2478, 1771, 2237, 2034, 234, 62, 554, 2127, 2124, 692, 190, 569, 475, 701, 559, 3, 100, 223, 315, 2285, 2119, 464,
	551, 1899, 68, 456, 11, 2121, 2122, 538, 300, 35, 541, 1875, 1715, 309, 1838, 567, 546, 188,
];

const providersMX = [
	119, 350, 337, 1853, 2142, 2107, 2, 283, 464, 692, 444, 1860, 2330, 677, 8, 1796, 568, 608, 1771, 190, 201, 262,
	300, 309, 315, 339, 457, 467, 473, 475, 531, 538, 546, 551, 554, 559, 569, 3, 10, 11, 66, 68, 73, 100, 167, 188,
	567, 582, 683, 689, 690, 701, 1715, 1825, 1866, 1875, 1889, 1899, 1968, 2106, 2141, 2158, 2160, 2161, 2162, 2163,
	2165, 2166, 2167, 2243, 2285, 2303, 2356, 2472, 2478, 35, 541, 1875, 1715, 309, 1838, 567, 546, 188,
];

const providersBR = [
	119, 337, 350, 1853, 2142, 2107, 2, 283, 1973, 692, 2330, 677, 444, 8, 1796, 2285, 112, 1975, 1978, 2077, 2212,
	2221, 2222, 2228, 201, 262, 300, 307, 309, 315, 447, 464, 473, 475, 477, 484, 499, 531, 538, 544, 546, 551, 562, 3,
	10, 11, 19, 47, 68, 167, 190, 554, 559, 567, 569, 582, 608, 683, 701, 1715, 1771, 1825, 1860, 1861, 1875, 1899,
	1920, 1945, 1968, 2106, 2141, 2156, 2157, 2158, 2159, 2160, 2243, 2303, 2356, 2472, 2478, 2488,
];

const buyboxSortingCountries = ['FR', 'IT', 'ES', 'MX', 'BR'] as const;

type buyboxSortingCountry = (typeof buyboxSortingCountries)[number];

export function isSortedBuyboxCountry(country: string): country is buyboxSortingCountry {
	return buyboxSortingCountries.includes(country as buyboxSortingCountry);
}

export const sortedBuyboxProvidersByCountry: Record<buyboxSortingCountry, number[]> = {
	FR: providersFR,
	IT: providersIT,
	ES: providersES,
	MX: providersMX,
	BR: providersBR,
};

export function sortBuyboxOffers(offers: BuyboxRegularOffer[], country: string) {
	if (!isSortedBuyboxCountry(country)) return offers;

	const provider_ids_sorted = sortedBuyboxProvidersByCountry[country];

	return offers.toSorted((a, b) => {
		const indexA = provider_ids_sorted.indexOf(a.package.packageId);
		const indexB = provider_ids_sorted.indexOf(b.package.packageId);

		if (indexA === -1 && indexB === -1) return 0; // both not found
		if (indexA === -1) return 1; // a not found, b found
		if (indexB === -1) return -1; // a found, b not found

		return indexA - indexB;
	});
}
